import { http } from '../../../api/axios';
import { localContentPrefix } from '../../../config';
import { Pagination } from '../../../../models/Pagination';
import { ProductFilter, ProductsResponseOut } from '../../../store/api';

interface AllTitlesParams {
    pagination: Pagination;
    ageCategory?: string | null;
    filterMap: ProductFilter;
    shopLanguage: string | undefined;
}

export const fetchAllTitlesProducts = ({ pagination, ageCategory, filterMap, shopLanguage }: AllTitlesParams) => {
    const { page, pageSize, sortBy } = pagination;

    return http.post<ProductsResponseOut>(`${localContentPrefix}/v1/marketplace/list/products`, filterMap, {
        params: {
            page,
            pageSize,
            sortBy,
            ageCategory: ageCategory ? ageCategory : undefined,
            shopLanguage
        }
    });
};
